import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1B8D4B',
        },
        secondary: {
            main: '#FFA500',
        },
        background: {
            default: '#fbfff9',
            paper: '#f0faf5',
        },
        divider: '#e0f2e9',
        text: {
            primary: '#0D0D0D',
            secondary: '#555',
        },
    },
    typography: {
        fontFamily: "'Alexandria', sans-serif",
        h1: {
            fontFamily: "'Comic Relief', cursive",
        },
        h2: {
            fontFamily: "'Comic Relief', cursive",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#20ba59',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f0faf5',
                    border: '1px solid #e0f2e9',
                    padding: '1rem',
                    marginBottom: '1rem',
                },
            },
        },
    },
});

export default theme;
